import React from 'react';

import { CmHeading } from '@/components/uiParts';

export const HeroLogo = (): JSX.Element => {
  return (
    <CmHeading size="2xl" as="h1" textAlign="center" mb={10} color="primaryRed">
      Camel
      <br />
      Dashboard
    </CmHeading>
  );
};
